import { PersonOutline } from '@mui/icons-material'
import { Button, Typography, Tooltip } from '@mui/material'
import { ReduxState, ReduxUser } from 'app/redux/ReduxInterfaces'
import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

export const UserProfileButton: React.FC<{ isSmallScreen?: boolean}> = ({ isSmallScreen =  false }) => {
  const user = useSelector<ReduxState, ReduxUser>(state => state.user)
  const history = useHistory()

  return (
    <div className='topbar-button-box'>
      <Button
        sx={{ padding: 0 }}
        variant='text'
        onClick={e => {
          history.push('/grants/user-profile')
        }}
      >
        {isSmallScreen ? (
          <Tooltip title={user.displayName}>
            <PersonOutline sx={{ color: 'primary.main', marginRight: '8px', fontSize: 24 }} />
          </Tooltip>
        ) : (
          <>
            <PersonOutline sx={{ color: 'primary.main', marginRight: '8px', fontSize: 24 }} />
            <Typography sx={{color: 'black'}}>
              {user.displayName}
            </Typography>
          </>
        )}
      </Button>
    </div>
  )
}
